import colors from './colors';

const analytics = {
  chartColor1: colors.primary,
  chartColor2: colors.purple,
  chartColor3: colors.green,
};

export default analytics;
